import React, { useState, useRef, useEffect, useMemo, useCallback } from "react";
import Select, { SelectInstance } from "react-select";

export interface DropdownOption {
  value: string | number;
  label: string;
}

interface DropdownProps {
  options: DropdownOption[]; // 中身の配列
  onChange?: (value: string | number) => void; // 選択時のコールバック
  className?: string;
  value?: DropdownOption;
  placeholder?: string;
  defaultValue?: DropdownOption | undefined; // 初期選択値
  addNewFirstLabel?: string; // リストの最初に追加する追加用ラベル
  addNewLastLabel?: string; // リストの最後に追加する追加用ラベル
  editable?: boolean; // 文字入力可能かどうか
  disabled?: boolean;
  "data-tooltip"?: string; // フォーカス時に表示するツールチップテキスト
}

export const Dropdown = (props: DropdownProps) => {
  const {
    options,
    onChange = () => { /**intentionally empty */ },
    className = "",
    placeholder,
    value,
    defaultValue,
    addNewFirstLabel = "", // 空文字の場合は先頭追加なし
    addNewLastLabel = "", // 空文字の場合は末尾追加なし
    editable = false,
    disabled = false,
    "data-tooltip": dataTooltip = "",
  } = props;

  const [showValue, setShowValue] = useState<DropdownOption | undefined>(undefined);
  const [inputValue, setInputValue] = useState<string>("");
  //useEffect(() => {
  //  const setDefalult = () => {
  //    if (defaultValue) {
  //      setShowValue(defaultValue);
  //    }
  //  };
  //  setDefalult();
  //}, [options]);
  //useEffect(() => {
  //  const setDefalult = () => {
  //    setShowValue(defaultValue);
  //  };
  //  setDefalult();
  //}, [defaultValue]);
  useEffect(() => {
    const setValue = () => {
      if (value) {
        setShowValue(value);
      } else {
        setShowValue(defaultValue);
      }
    };
    setValue();
  }, [value]);
//  const [highlightIndex, setHighlightIndex] = useState<number>(-1); // キーボードでの選択
  const wrapperRef = useRef<HTMLDivElement | null>(null);
  const selectRef = useRef<SelectInstance<DropdownOption> | null>(null);
  const [menuIsOpen, setMenuIsOpen] = useState(false);

  // リスト作成
  const fixOptions = useMemo(() => {
    // 入力可能の場合は入力値で絞り込み
    let filteredOptions: DropdownOption[] = [];
    if (!editable || !inputValue) {
      filteredOptions = options;
    } else {
      filteredOptions = options.filter(o => o.label.startsWith(inputValue));
    }

    // 先頭・末尾追加ラベルがあれば追加してリスト確定
    const fixedFirstOption = [{ value: "__FIXED_FIRST__", label: addNewFirstLabel }];
    const fixedLastOption = [{ value: "__FIXED_LAST__", label: addNewLastLabel }];
    let listAddedOptions = addNewFirstLabel !== "" ? [...fixedFirstOption, ...filteredOptions] : filteredOptions;
    listAddedOptions = addNewLastLabel !== "" ? [...listAddedOptions, ...fixedLastOption] : listAddedOptions;
    return listAddedOptions;
  }, [options, inputValue, editable, addNewFirstLabel, addNewLastLabel]);

  // 外部クリックで閉じる
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
//        setHighlightIndex(-1);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // 値選択時の処理
  const selectValue = useCallback((option: DropdownOption) => {
    onChange?.(option.value);
//    setHighlightIndex(-1);
  }, [onChange]);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && !menuIsOpen) {
      e.preventDefault();
      setMenuIsOpen(true);
    }
    if (e.key === "Tab" && menuIsOpen) {
      setMenuIsOpen(false);
    }
  };

  return (
    dataTooltip !== "" ? (
      <div data-tooltip={dataTooltip}>
        <Select<DropdownOption>
          ref={selectRef}
          options={fixOptions}
          value={showValue}
          defaultValue={defaultValue}
          placeholder={placeholder}
          noOptionsMessage={() => "（該当なし）"}
          onChange={(selected) => {
            if (selected) {
              setShowValue(selected);
              selectValue(selected);
            }
            setMenuIsOpen(false);
          }}
          menuIsOpen={menuIsOpen}
          onMenuOpen={() => setMenuIsOpen(true)}
          onMenuClose={() => setMenuIsOpen(false)}
          onKeyDown={handleKeyDown}
          tabSelectsValue={false}
          className={className}
          classNamePrefix="dropdown"
          isSearchable={editable}
          isClearable={editable}
          {...(editable && {inputValue: inputValue})}
          {...(editable && { onInputChange: (input) => setInputValue(input) })}
          isDisabled={disabled}
        />
      </div>
    ) : (
      <Select<DropdownOption>
        ref={selectRef}
        options={fixOptions}
        value={showValue}
        defaultValue={defaultValue}
        placeholder={placeholder}
        noOptionsMessage={() => "（該当なし）"}
        onChange={(selected) => {
          if (selected) {
            setShowValue(selected);
            selectValue(selected);
          }
          setMenuIsOpen(false);
        }}
        menuIsOpen={menuIsOpen}
        onMenuOpen={() => setMenuIsOpen(true)}
        onMenuClose={() => setMenuIsOpen(false)}
        onKeyDown={handleKeyDown}
        tabSelectsValue={false}
        className={className}
        classNamePrefix="dropdown"
        isSearchable={editable}
        isClearable={editable}
        {...(editable && {inputValue: inputValue})}
        {...(editable && { onInputChange: (input) => setInputValue(input) })}
        isDisabled={disabled}
      />
    )
  )
};